export enum StatusNFeEntradaEnum {
  CapturadaSefaz = 1,
  EmLancamento = 2,
  Lancada = 3,
}
